import Layout from "../Components/Layout";
import Journey from "../Components/Journey";

function JourneyPage() {
    return (
        <Layout>
            <Journey />
        </Layout>
    )
}

export default JourneyPage;